import Object3D from "./Object3D";

export default class RenderableObject3D extends Object3D {
  constructor(geometry, material) {
    super();
    this.isRenderable = true;
    this.geometry = geometry;
    this.material = material;
  }

  setGLContext(gl) {
    this._gl = gl;
    this.geometry.setGLContext(this._gl);
    this.material.setGLContext(this._gl);
    super.setGLContext(gl);
  }

  get glProgram() {
    return this.material && this.material.glProgram;
  }

  setMaterial(material) {
    this.material = material;
  }

  render() {
    if (!this._gl) {
      console.error("webgl context is null");
      return;
    }
    this._gl.useProgram(this.material.glProgram);

    this.material.enableCullingSetting();
    this.material.enableBlendSetting();
    this.material.enableDepthSetting();
    this.material.enableUniforms();
    this.geometry.enableAttributes(this.material.glProgram);

    this.geometry.drawGeometry();

    this.geometry.disableAttributes(this.material.glProgram);
  }

  dispose(disposeAll = false) {
    if (disposeAll) {
      if (this.geometry) this.geometry.dispose();
      if (this.material) this.material.dispose();
      this.geometry = null;
      this.material = null;
    }

    this._gl = null;
    super.dispose(disposeAll);
  }
}
